var Chaplin, HeaderView, Thumbnails, View, config, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Chaplin = require('chaplin');

View = require('views/base/view');

template = require('views/templates/header');

Thumbnails = require('views/thumbnails-view');

config = require('config');

module.exports = HeaderView = (function(_super) {
  __extends(HeaderView, _super);

  function HeaderView() {
    _ref = HeaderView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  HeaderView.prototype.autoRender = false;

  HeaderView.prototype.className = 'header';

  HeaderView.prototype.region = 'header';

  HeaderView.prototype.id = 'header';

  HeaderView.prototype.template = template;

  HeaderView.prototype.listen = {
    'catalogue:initCompleted mediator': 'showHeader'
  };

  HeaderView.prototype.regions = {
    "#thumbs-holder": 'thumbs'
  };

  HeaderView.prototype.events = {
    'click .btn-page-next': 'nextPage',
    'click .btn-page-prev': 'prevPage',
    'click .btn-page-start': 'toStart',
    'click .btn-page-end': 'toEnd',
    'submit #page-num-form': 'goToPage',
    'click .btn-zoom-in': 'zoomIn',
    'click .btn-zoom-out': 'zoomOut',
    'click #btn-search': 'search',
    'click #search-form': 'search',
    'click #btn-print': 'print',
    'click .btn-thumbnails': 'thumbnails',
    'click .btn-list': 'list',
    'click .btn-email': 'email',
    'click #btn-download': 'download',
    'click .btn-bookmarks-new': 'bookmarksOpen',
    'click .btn-bookmarks-load': 'bookmarksOpen',
    'click .btn-bookmarks-save': 'bookmarksOpen',
    'click .btn-bookmarks-manage': 'bookmarksOpen',
    'click.spec .btn-bookmarks-new': 'bookmarksNew',
    'click.spec .btn-bookmarks-load': 'bookmarksLoad',
    'click.spec .btn-bookmarks-save': 'bookmarksSave',
    'click.spec .btn-bookmarks-manage': 'bookmarksManage',
    'click .btn-notes-new': 'notesOpen',
    'click .btn-notes-load': 'notesOpen',
    'click .btn-notes-save': 'notesOpen',
    'click .btn-notes-manage': 'notesOpen',
    'click.spec .btn-notes-new': 'notesNew',
    'click.spec .btn-notes-load': 'notesLoad',
    'click.spec .btn-notes-save': 'notesSave',
    'click.spec .btn-notes-manage': 'notesManage'
  };

  HeaderView.prototype.attach = function() {
    HeaderView.__super__.attach.apply(this, arguments);
    return this.createThumbnails();
  };

  HeaderView.prototype.showHeader = function() {
    return this.$('nav').removeClass('hidden');
  };

  HeaderView.prototype.nextPage = function() {
    this.publishEvent('catalogue:next');
    return false;
  };

  HeaderView.prototype.prevPage = function() {
    this.publishEvent('catalogue:previous');
    return false;
  };

  HeaderView.prototype.toStart = function() {
    this.publishEvent('catalogue:goToStart');
    return false;
  };

  HeaderView.prototype.toEnd = function() {
    this.publishEvent('catalogue:goToEnd');
    return false;
  };

  HeaderView.prototype.goToPage = function() {
    var page;
    page = parseInt(this.$('#page-num').val());
    if (!isNaN(page)) {
      this.publishEvent('catalogue:goToPageByPageNumber', page);
    }
    return false;
  };

  HeaderView.prototype.search = function() {
    var keyWord;
    keyWord = this.$('#search').val();
    if (!keyWord.length) {
      return false;
    }
    this.publishEvent('catalogue:searchByKeyWord', keyWord);
    return false;
  };

  HeaderView.prototype.zoomIn = function() {
    this.publishEvent('catalogue:zoomIn');
    return false;
  };

  HeaderView.prototype.zoomOut = function() {
    this.publishEvent('catalogue:zoomOut');
    return false;
  };

  HeaderView.prototype.print = function() {
    this.publishEvent('catalogue:print');
    return false;
  };

  HeaderView.prototype.thumbnails = function() {
    this.publishEvent('catalogue:thumbnails');
    return false;
  };

  HeaderView.prototype.list = function() {
    this.publishEvent('catalogue:list');
    return false;
  };

  HeaderView.prototype.bookmarksOpen = function() {
    this.publishEvent('catalogue:bookmarksOpen');
    return false;
  };

  HeaderView.prototype.bookmarksManage = function() {
    this.publishEvent('catalogue:bookmarksManage');
    return false;
  };

  HeaderView.prototype.bookmarksLoad = function() {
    this.publishEvent('catalogue:bookmarksLoad');
    return false;
  };

  HeaderView.prototype.bookmarksNew = function() {
    this.publishEvent('catalogue:bookmarksNew');
    return false;
  };

  HeaderView.prototype.bookmarksSave = function() {
    return this.publishEvent('catalogue:bookmarksSave');
  };

  HeaderView.prototype.notesOpen = function() {
    this.publishEvent('catalogue:notesOpen');
    return false;
  };

  HeaderView.prototype.notesManage = function() {
    this.publishEvent('catalogue:notesManage');
    return false;
  };

  HeaderView.prototype.notesLoad = function() {
    this.publishEvent('catalogue:notesLoad');
    return false;
  };

  HeaderView.prototype.notesNew = function() {
    this.publishEvent('catalogue:notesNew');
    return false;
  };

  HeaderView.prototype.notesSave = function() {
    this.publishEvent('catalogue:notesSave');
    return false;
  };

  HeaderView.prototype.email = function() {
    this.publishEvent('catalogue:sendEmail');
    return false;
  };

  HeaderView.prototype.download = function() {
    window.location.href = "" + config.api.root + "catalogues/" + (Chaplin.mediator.catalogue.get('info').folder) + "/pdf_files/uploaded.pdf";
    return false;
  };

  HeaderView.prototype.createThumbnails = function() {
    var thumbnails;
    thumbnails = new Thumbnails({
      region: 'thumbs'
    });
    return this.subview('thumbnails', thumbnails);
  };

  return HeaderView;

})(View);
